import { createContext } from "react";

import { IRydeTable, IRydeTableOptions, ITableDto } from "@ryde/shared";

interface ITableOptionsContext {
  table?: IRydeTable<ITableDto>;
  tableOptions?: IRydeTableOptions<ITableDto>;
}

export const TableOptionsContext = createContext<ITableOptionsContext>({});
